import React from 'react';
import Select, { ISelectProps } from './Select';

interface IMultiDropdownProps {
  configList: ISelectProps[];
}

const CascadingSelect: React.FC<IMultiDropdownProps> = ({ configList }) => (
  <>
    {configList.map(config => (
      <Select key={config.name} label={config.name} {...config} />
    ))}
  </>
);

export default CascadingSelect;
